import React from "react";
import { useOutletContext } from "react-router-dom";
import { CSIODocsTableList } from "../../../../../csioEdocs/CSIODocsTable";
import { PageContainer } from "../../../../../../components/container/PageContainer";

export const HabitationalCSIOEDIList: React.FC = () => {
    const data1 = useOutletContext() as any;
    const customerpolicyId = data1[1];

    return(
        <PageContainer title="CSIO " description="this is inner page">
          <CSIODocsTableList customerPolicyId={customerpolicyId}/>
        </PageContainer>
    )
}
